<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('Procesos')"
          directory=""
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="
              () => {
                $hub.$emit('reload-' + tableId);
              }
            "
          >
            <i data-feather="refresh-ccw" class="pr-2" /> Refrescar
          </button>
        </div>
      </div>
    </div>
    <app-table :id="tableId" :options="options" />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../apiUrl";
import { TableHelpers } from "./TableHelpers";

export default {
    extends: CoreLibrary,
    mixins: [TableHelpers],
    data() {
        return {
            tableId: "delays-table",
            rowData: {},
            options: {
                name: "delays-table",
                url: "/process-delays/indexInProgress",
                showHeader: true,
                columns: [],
                filters: [
                {
                    title: "Actividad",
                    type: "checkbox",
                    key: "accreditation_activity",
                    option: [],
                },
                {
                    title: "Tipo",
                    type: "checkbox",
                    key: "accreditation_type",
                    option: [],
                },
                ],
                showFilter: true,
                showSearch: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: "desc",
                actionType: "default",
            },
        };
    },
    created() {
    this.options.columns = [...this.tableColumns];
    this.data();
  },
  methods: {
    data() {
      const url = "historical/getOptions";
      this.axiosGet(url).then((response) => {
        if (response.status == 200) {
          this.searchAndSelectFilterOptions(response.data);
        }
      });
    },
    searchAndSelectFilterOptions(options) {
      const activity = this.options.filters.find(
          (element) => element.key === "accreditation_activity"
      );
      activity.option = options.accreditationActivities;

      const type = this.options.filters.find(
          (element) => element.key === "accreditation_type"
      );
      type.option = options.accreditationTypes;
    },
  }
}
</script>

<style>
.badge-testp1 {
   color: #FDFEFE;
   background-color: #7f0000;
}
.badge-testp2 {
   color: #FDFEFE;
   background-color: #bd0003;
}
.badge-testp3 {
   color: #FDFEFE;
   background-color: #ff0000;
}
</style>